import FacebookSvg from '@assets/images/svg/facebook.svg';
import React from 'react';
import { View } from 'react-native';

export interface FacebookIconProps {
    size?: number;
    color?: string;
}

export const FacebookIcon = React.memo<FacebookIconProps>(function FacebookIcon({
    size = 24,
    color = '#333333',
}) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <FacebookSvg width={size} height={size} color={color} />
        </View>
    );
});

export default FacebookIcon;


